import { FC } from 'react';
import { getToday } from 'components/forms/AgreementInfo';
import classlist from 'utils/classlist';
import styles from './style.scss';

interface SignatureProps {
    className?: string;
    name: string;
    date?: string;
}

const Signature: FC<SignatureProps> = ({ className, name, date }) => {
    return (
        <div className={classlist(styles.root, className)}>
            <label className={styles.label}>{__('Signature')}</label>
            <p className={styles.value}>{name}</p>
            <label className={styles.label}>{__('Date')}</label>
            <p className={styles.value}>{date || getToday()}</p>
        </div>
    );
};

export default Signature;
